<template>
  <tr
    class="table__row relative"
    :class="{ 'table__row--expanded': isChildRow }"
    @mouseenter="renderRowActions(true)"
    @mouseleave="renderRowActions(false)"
  >
    <td v-for="header in headers" :key="header.value" :style="columnStyle(header)">
      <template v-if="header.value === 'expand'">
        <v-btn
          v-if="item.isExpandable"
          icon
          small
          @click.stop="$emit('expand')"
          :style="[isExpanded ? { transform: 'rotate(180deg)' } : {}]"
        >
          <v-icon color="#2CB56B">
            mdi-chevron-up
          </v-icon>
        </v-btn>
      </template>
      <template v-else-if="!shouldShowCell(header.value)">
        <span />
      </template>
      <template v-else-if="header.value === 'name'">
        <span style="white-space: nowrap;">
          {{ item.name }}
        </span>
      </template>
      <template v-else-if="header.value === 'available'">
        <div
          class="select-status"
          style="width: min-content;"
          :class="`select-status--${item.available ? 'green' : 'red'}`"
        >
          {{ item.available ? 'Wolny' : 'Zajęty' }}
        </div>
      </template>
      <template v-else-if="header.value === 'direction'">
        <div :class="driverDirectionConfig.class">
          {{ driverDirectionConfig.label }}
        </div>
      </template>
      <template v-else-if="header.value === 'timeToDestination'">
        <div>{{ item.timeToDestination ? parseSeconds(item.timeToDestination) : '-' }}</div>
      </template>
      <template v-else-if="header.value === 'distanceToDestination'">
        <div>
          {{
            item.distanceToDestination != null
              ? (item.distanceToDestination / 1000).toFixed(2) + ' km'
              : '-'
          }}
        </div>
      </template>
      <template v-else-if="header.value === 'distanceCovered'">
        <div>{{ item.distanceCovered ? (item.distanceCovered / 1000).toFixed(2) + ' km' : '-' }}</div>
      </template>
      <template v-else-if="header.value === 'containerTypeVolume'">
        <div>{{ item.containerTypeVolume ? item.containerTypeVolume / 1000 + ' m³' : '-' }}</div>
      </template>
      <template v-else-if="header.value === 'trailerId'">
        <v-checkbox
          :input-value="item.trailerId != null"
          class="mb-1"
          style="margin: 0 auto; width: min-content;"
          hide-details
          readonly
        />
      </template>
      <template v-else-if="header.value === 'actions'">
        <div class="relative h-100 px-6">
          <TableColumnActions
            v-if="showActions"
            table-name="driversOccupancy"
            :item="item"
            :static-actions="rowActions"
            :offset="actionsOffset"
          />
        </div>
      </template>
      <template v-else>
        {{ displayValue(item[header.value]) }}
      </template>
    </td>
  </tr>
</template>

<script>
import parseSeconds from '../../utils/parseSeconds'
import TableColumnActions from '../Table/Columns/TableColumnActions'
import { shouldShowOccupancyCell } from '../../utils/driversOccupancyRows'

export default {
  components: {
    TableColumnActions
  },
  props: {
    item: {
      type: Object,
      required: true
    },
    headers: {
      type: Array,
      required: true
    },
    rowActions: {
      type: Array,
      required: true
    },
    actionsOffset: {
      type: Object,
      required: true
    },
    isChildRow: {
      type: Boolean,
      default: false
    },
    isExpanded: {
      type: Boolean,
      default: false
    }
  },
  data: () => ({
    showActions: false
  }),
  computed: {
    driverDirectionConfig() {
      const groupedCourseWithDirection = this.item.groupedCourses?.find(course => course.direction)
      const direction = this.item.direction || groupedCourseWithDirection?.direction

      if (!direction) {
        return { label: '-', class: 'text-body-2' }
      }

      return {
        label: direction,
        class: direction === 'Klient' ? 'error--text' : 'primary--text'
      }
    }
  },
  methods: {
    parseSeconds,
    columnStyle(header) {
      if (!this.isChildRow || !header.width) {
        return {}
      }

      return {
        minWidth: `${header.width}px`
      }
    },
    shouldShowCell(columnValue) {
      return shouldShowOccupancyCell(columnValue, this.item)
    },
    displayValue(value) {
      return value == null || value === '' ? '-' : value
    },
    renderRowActions(showActions = false) {
      this.showActions = showActions
    }
  }
}
</script>
